exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-braindumps-tsx": () => import("./../../../src/pages/braindumps.tsx" /* webpackChunkName: "component---src-pages-braindumps-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-braindumps-tsx": () => import("./../../../src/templates/braindumps.tsx" /* webpackChunkName: "component---src-templates-braindumps-tsx" */)
}

